/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Bullet_ListInputs */



/**
* | output |
* | --- |
* | "Bulleted list" |
*
* @param {Rte_Bullet_ListInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_bullet_list = /** @type {((inputs?: Rte_Bullet_ListInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Bullet_ListInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opsomming")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste à puces")
	return /** @type {LocalizedString} */ ("Bulleted list")
});